import { render, staticRenderFns } from "./EditCategorySubcategory.vue?vue&type=template&id=eb627870&scoped=true"
import script from "./EditCategorySubcategory.vue?vue&type=script&lang=js"
export * from "./EditCategorySubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb627870",
  null
  
)

export default component.exports